import { FC } from 'react';
import clsx from 'clsx';

import { Button, Text } from '@auspost/postmaster-react';

import styles from './ExtraContentCta.module.scss';

interface Props {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | React.ReactNode | JSX.Element;
  buttonText: string;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode | JSX.Element;
}

export const ExtraContentCta: FC<Props> = ({ icon, buttonText, className, onClick, children, ...props }) => {
  const classNames = clsx(styles.cta, className);
  const IconComponent = typeof icon === 'function' ? icon : () => icon as JSX.Element;
  return (
    <div className={styles.ctaContainer} {...props}>
      <Button
        variant='secondary'
        size='large'
        icon={<IconComponent />}
        onClick={onClick}
        type='button'
        className={classNames}
      >
        <Text variant='body-small' weight='medium'>
          {buttonText}
        </Text>
      </Button>
      {children}
    </div>
  );
};

export default ExtraContentCta;
